import { action, observable } from 'mobx';
import { ADVISOR_LOGO, ADVISOR_LOGO_FORCE } from 'api/endpoints';
import { RootStore } from 'stores/rootStore';
import { LogoData } from 'stores/userStoreKC';

export class LogoStore {
  rootStore: RootStore;

  @observable data: LogoData | null = null;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }

  @action
  fetchLogo = async () => {
    this.rootStore.stores.uiStore.setLoading(true);
    const response = await this.rootStore.stores.apiStore.get<LogoData>(ADVISOR_LOGO_FORCE);
    if (response?.data) {
      this.data = response.data;
      if (response.data.custom === undefined) this.data.custom = false;
    }
    this.rootStore.stores.uiStore.setLoading(false);
    return response;
  };

  @action
  uploadLogo = async (base64?: string) => {
    this.rootStore.stores.uiStore.setLoading(true);
    await this.rootStore.stores.apiStore.post(ADVISOR_LOGO, { custom: true, data: base64 });
    await this.fetchLogo();
    await this.rootStore.stores.userStore.fetchAdvisorLogo();
    this.rootStore.stores.uiStore.setLoading(false);
  };

  @action
  deleteLogo = async () => {
    this.rootStore.stores.uiStore.setLoading(true);
    await this.rootStore.stores.apiStore.delete(ADVISOR_LOGO);
    await this.fetchLogo();
    await this.rootStore.stores.userStore.fetchAdvisorLogo();
    this.rootStore.stores.uiStore.setLoading(false);
  };

  @action
  setCustom = async (custom: boolean) => {
    if (this.data) {
      this.data.custom = custom;
      this.rootStore.stores.uiStore.setLoading(true);
      await this.rootStore.stores.apiStore.post(ADVISOR_LOGO, { custom: this.data.custom });
      await this.fetchLogo();
      await this.rootStore.stores.userStore.fetchAdvisorLogo();
      this.rootStore.stores.uiStore.setLoading(false);
    }
  };
}
